import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import Seo from '../components/Seo';
import ServiceEnquiry from '../components/ServiceEnquiry';
import { SERVICES, DIVISIONS } from '../mock';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function Services() {
  return (
    <div>
      <Seo title="Our Services | Fixed Group — PTI, Reefer Repair, Cold Rooms & Haulage" description="End-to-end cold chain services: Pre-Trip Inspections, reefer container repair & leasing, refrigerated haulage, cold room construction and RRMS monitoring." />
      <PageHeader title="Our Services" crumbs={[{ label: 'Services' }]} />

      <section className="py-16">
        <div className="fx-container">
          <div className="max-w-3xl">
            <span className="text-xs uppercase tracking-widest text-emerald-600 font-semibold">What we offer</span>
            <h2 className="section-title text-3xl md:text-4xl font-extrabold mt-2">End-to-end cold chain services</h2>
            <p className="mt-6 text-slate-600 leading-relaxed">From pre-trip inspections and reefer container repair to on-road cold chain haulage and cold room construction, the Fixed Group covers every touchpoint that keeps refrigerated cargo safe.</p>
          </div>

          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s, i) => (
              <div key={i} className="fx-card overflow-hidden group">
                <div className="h-48 overflow-hidden">
                  <img src={s.image} alt={s.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6">
                  <h3 className="font-bold text-slate-900 text-lg">{s.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                  <ServiceEnquiry service={s.title} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="fx-container">
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-xs uppercase tracking-widest text-emerald-600 font-semibold">Explore by company</span>
            <h2 className="section-title center text-3xl md:text-4xl font-extrabold mt-2">Services by Division</h2>
          </div>
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            {DIVISIONS.map((d) => (
              <Link key={d.slug} to={`/divisions/${d.slug}`} className="fx-card p-6 group">
                <div className="text-xs uppercase tracking-widest text-emerald-600">{d.short}</div>
                <h3 className="mt-2 font-bold text-lg text-slate-900">{d.name}</h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{d.tagline}</p>
                <ul className="mt-4 space-y-2 text-sm text-slate-700">
                  {d.services.slice(0,4).map((sv, i) => (
                    <li key={i} className="flex items-start gap-2"><CheckCircle2 size={16} className="text-emerald-500 mt-0.5 flex-shrink-0" />{sv}</li>
                  ))}
                </ul>
                <span className="mt-5 inline-flex items-center gap-2 text-emerald-700 font-semibold group-hover:text-emerald-800">Explore division <ArrowRight size={14} /></span>
              </Link>
            ))}
          </div>
          <div className="mt-12 text-center">
            <Button asChild data-testid="services-contact-btn" className="bg-emerald-600 hover:bg-emerald-700 text-white rounded-full px-8 py-6 text-base shadow-lg shadow-emerald-600/25"><Link to="/contact">Request a Quote <ArrowRight className="ml-2" size={16} /></Link></Button>
          </div>
        </div>
      </section>
    </div>
  );
}
